/**
 * 履歴画面の表示ラベル (マスタ変更履歴 SBI 7)。
 *
 * コンポーネントと同じファイルから定数を export すると Fast Refresh の警告が出るため、
 * コンポーネント外で共有する値はこのファイルに置く (`dateTime.ts` と同じ理由)。
 */
import type { MasterHistoryAction, MasterHistoryChangeKind, MasterHistoryType } from '../api/types';

export const MASTER_HISTORY_TYPE_LABEL: Readonly<Record<MasterHistoryType, string>> = {
  broadcast_spot: '放送地点',
  chime: 'チャイム',
  phrase_template: '定型文',
  ssml_dictionary: 'SSML 辞書',
  free_text_template: '任意テキスト',
  permission_group: '権限グループ',
  device: '端末',
};

/** 履歴から戻る先の現場WG画面の名前 (戻るボタンの文言に使う) */
export const MASTER_HISTORY_SOURCE_SCREEN_LABEL: Readonly<Record<MasterHistoryType, string>> = {
  broadcast_spot: '放送地点',
  chime: 'チャイム音',
  phrase_template: '定型文',
  ssml_dictionary: 'SSML 辞書',
  free_text_template: '任意テキスト',
  permission_group: '権限グループ',
  device: '端末',
};

export const MASTER_HISTORY_ACTION_LABEL: Readonly<Record<MasterHistoryAction, string>> = {
  CREATE: '新規登録',
  UPDATE: '更新',
  DELETE: '削除',
  REBOOT: '再起動',
};

/** 項目ごとの差分の種類 (追加 / 削除 / 変更) */
export const MASTER_HISTORY_CHANGE_KIND_LABEL: Readonly<Record<MasterHistoryChangeKind, string>> = {
  added: '追加',
  removed: '削除',
  changed: '変更',
};
